import React, { FC } from 'react';
import { ILegoElemText } from '../models';
import type { ILegoElemProps } from '../../Lego';
import { Text } from '@src/atoms/Text';

export const LegoElemText: FC<ILegoElemProps> = ({ elem }) => {
  const legoElem = elem as ILegoElemText;

  return <Text {...legoElem.text}>{legoElem.content}</Text>;
};
